import React from 'react';
import { Button, Spin } from 'antd';

const BulkAddToRoutePlanError = ({ isFetching, handleCancel, message }) => {
  return (
    <Spin spinning={isFetching}>
      <div className="BulkAddToRoutePlanError">
        <div className="FormContent">{message}</div>
        <div className="FormFooter">
          <div className="Left"></div>
          <div className="Right">
            <Button type="primary" onClick={handleCancel}>
              OK
            </Button>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default BulkAddToRoutePlanError;
